package org.example.project.dashboard

import androidx.compose.runtime.mutableStateOf

object MobileDashboardBackHandler {
    val handler = mutableStateOf<(() -> Boolean)?>(null)
}
